import React from 'react';

import { Box } from '@material-ui/core';

import styles from './styles.module.scss';

const GoalsTab = () => (
  <Box className={styles.placeholderContainer}>
    <span className={styles.badge}>Coming Soon</span>
  </Box>
);

export default GoalsTab;
